// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"295":"ba5ec82c","455":"cb2bb356"}[chunkId] + ".chunk.css";
};